import React from 'react';

import { ButtonBase, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import LaunchIcon from '@mui/icons-material/Launch';

interface Props {
	href: string;
	text: string;
	onClick?: () => void;
}

const ExternalLinkButton = (props: Props) => {
	const classes = useStyles();

	return (
		<a href={props.href} target="_blank" rel="noopener noreferrer" onClick={props.onClick}>
			<ButtonBase className={classes.wrapper}>
				<Typography variant="body2" color="textPrimary" className={classes.text}>
					{props.text}
				</Typography>
				<LaunchIcon className={classes.icon} />
			</ButtonBase>
		</a>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		wrapper: {
			paddingLeft: theme.spacing(1.5),
			paddingRight: theme.spacing(1.5),
			borderRadius: '3px',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
		},
		text: {
			marginRight: theme.spacing(1),
			fontWeight: 500,
			textTransform: 'uppercase',
		},
		icon: {
			fontSize: '1.5rem',
			color: theme.palette.text.primary,
		},
	}),
);

export default ExternalLinkButton;
